import React from "react";
import {
    useAppSelector,
} from "../../../../app/hooks";
import Account from "../../../VirtualAccount/components/Account";
import { CURRENCIES_ALLOWED_FOR_VA } from "../../../Wallets/utils";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { FEATURE_FLAG_KEYS } from "../../../../utils/featureFlags";
import SettlementTransactionsTable from "../../components/SettlementTransactionsTable";

const tooltipText =
    "Settlement balance gets funded with funds from your virtual accounts 1:00AM daily.";

const Settlements = () => {
    const { wallets } = useAppSelector(
        (state) => state?.wallets,
    );

    const enableVirtualAccountsV2 = useFeatureFlagEnabled(FEATURE_FLAG_KEYS.virtualAccountsV2);
    const virtualAccountWallets = wallets?.filter((item) => CURRENCIES_ALLOWED_FOR_VA.includes(item.currency) && item.currency !== 'KES' && (enableVirtualAccountsV2 || item.currency !== 'GHS'))

    return (
        <div>
            <Account
                title="Settlement balance"
                baseUrlForRedirection="settlements"
                tooltipText={tooltipText}
                wallets={virtualAccountWallets}
            />

            <SettlementTransactionsTable />
        </div>
    );
};

export default Settlements;
